// extracted by mini-css-extract-plugin
export default {"logo":"prioritisation_logo__mWvat","logoContainer":"prioritisation_logoContainer__uC2x+"};